import { render } from "./ai-grid-ro-wrapper.vue?vue&type=template&id=6998b694"
import script from "./ai-grid-ro-wrapper.vue?vue&type=script&setup=true&lang=js"
export * from "./ai-grid-ro-wrapper.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/wrappers/ai-grid-ro-wrapper.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6998b694"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6998b694', __exports__)) {
    api.reload('6998b694', __exports__)
  }
  
  module.hot.accept("./ai-grid-ro-wrapper.vue?vue&type=template&id=6998b694", () => {
    api.rerender('6998b694', render)
  })

}


export default __exports__